import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';
import getFirebaseMessaging from '@/features/push/functions/get-firebase-messaging';
import { showBrowserNotification } from '@/features/push/functions/show-browser-notification';
import useHandleNotificationClick from '@/features/push/hooks/useHandleNotificationClick';
import { useQueryClient } from '@tanstack/react-query';
import { onMessage } from 'firebase/messaging';
import { useEffect } from 'react';

export default function usePushWebMessageListener() {
  const featureFlags = useFeatureFlags();
  const handleNotificationClick = useHandleNotificationClick();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!featureFlags.push.enabled || window.ReactNativeWebView) return;
    let unsubscribe: (() => void) | undefined;

    getFirebaseMessaging().then((messaging) => {
      if (!messaging) return;
      unsubscribe = onMessage(messaging, (payload) => {
        queryClient.invalidateQueries({ queryKey: ['notifications'] });
        const notification = showBrowserNotification({
          title: payload.notification?.title ?? 'Notification',
          body: payload.notification?.body,
          icon: payload.notification?.icon,
          image: payload.notification?.image,
          data: payload.data,
        });
        if (!notification) return;

        console.log('onMessage', payload.notification, payload.data);
        notification.onclick = () => {
          notification.close();
          window.focus();
          handleNotificationClick(payload.notification, payload.data);
        };
      });
    });
    return () => unsubscribe?.();
  }, [featureFlags.push.enabled, handleNotificationClick, queryClient]);
}
